import * as types from '../constants/ActionTypes';
import * as contactTypes from '../../contactUs/constants/ActionTypes';

const initialState = {
  defaultTopReason: [],
  isDisplayTopReason: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.DEFAULT_TOP_SEARCH_REASON:
      return Object.assign({}, state, { defaultTopReason: action.payload });
    case types.DEFAULT_TOP_SEARCH_REASON_ERROR:
      return Object.assign({}, state, { defaultTopReason: [] });
    case types.SHOW_TOP_CONTACT_REASON:
      return Object.assign({}, state, { isDisplayTopReason: true });
    case types.HIDE_TOP_CONTACT_REASON:
    case contactTypes.SPEECH_START_RECORDING:
    case contactTypes.SPEECH_RECOGNITION_REQUEST:
    case contactTypes.SPEECH_END_REQUEST:
      return Object.assign({}, state, { isDisplayTopReason: false });
    default:
      return state;
  }
}
